/**
 * Client-safe constants and literal types for the `bundle_recompute` kind.
 *
 * This module deliberately has NO imports from zod, the DAL, or any other
 * server-oriented surface — it can be safely imported from React client
 * components that need to display the cap, validate UI ranges, or build
 * a request payload.
 *
 * The full job_type module `lib/jobs/bundle-recompute.ts` re-uses these
 * constants when constructing the zod schemas (preserving a single source
 * of truth) and adds the schema + DAL-wrapper surface on top.
 */

export const BUNDLE_RECOMPUTE_JOB_TYPE = "bundle_recompute" as const

// Order-count bounds for one recompute job.
//   - RECOMPUTE_LIMIT_MAX: hard ceiling. Large runs no longer have to fit one
//     serverless window — the worker processes in time-budgeted chunks and a
//     cron resumer continues across windows (see lib/shopify/bundles/
//     recompute-worker.ts).
//   - RECOMPUTE_LIMIT_DEFAULT: schema default when the field is omitted.
//   - RECOMPUTE_LIMIT_FIELD_DEFAULT: pre-fill for the dialog's «Maximum orders»
//     input (preserves the historical recent-orders behavior).
export const RECOMPUTE_LIMIT_MIN = 1
export const RECOMPUTE_LIMIT_MAX = 100_000
export const RECOMPUTE_LIMIT_DEFAULT = 200
export const RECOMPUTE_LIMIT_FIELD_DEFAULT = 5_000

export const RECOMPUTE_CONCURRENCY_MIN = 1
export const RECOMPUTE_CONCURRENCY_MAX = 10
export const RECOMPUTE_CONCURRENCY_DEFAULT = 10

export const BUNDLE_RECOMPUTE_MODES = [
  "both",
  "families-only",
  "bundles-only",
] as const
export type BundleRecomputeMode = (typeof BUNDLE_RECOMPUTE_MODES)[number]

export const RECOMPUTE_MODE_DEFAULT: BundleRecomputeMode = "both"
